import { Component, OnInit, ViewChild } from '@angular/core';
import { StaticDataService } from '../../../services/static-data.service';
import { EnumValidValueItemModel } from '../../../models/enum/enum-valid-value-item.model';
import { OperatoriesService } from '../../../modules/configuration/operatories/operatories.service';
import { OperatoryDataModel } from '../../../models/clients/operatory-data.model';
import { Globals } from '../../../globals';
import { NotificationToFrontService } from '../../../services/messaging/notification-to-front.service';
import { NotificationToFrontDataModel } from '../../../models/messaging/noteToFront/notification-to-front-data.model';
import { UserService } from '../../../services/user.service';
import { TdoUserConfigurationModel } from '../../../models/configuration/user/tdo-user-configuration.model';
import { NotificationToFrontAppointmentDataModel } from '../../../models/messaging/noteToFront/notification-to-front-appointment-data.model';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { NotificationToFrontItemsNeededDialogComponent } from './dialog/notification-to-front-items-needed-dialog/notification-to-front-items-needed-dialog.component';
import { ToothService } from '../../../services/tooth.service';
import { ToothConfigurationModel } from '../../../models/teeth/tooth-configuration.model';
import { Constants } from '../../../constants';
import { NotificationToFrontOperatoryDataModel } from '../../../models/messaging/noteToFront/notification-to-front-operatory-data.model';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';
import { NextCallWhenEnum } from '../../../models/enum/notification/next-call-when.enum';
import { formatDate } from '@angular/common';
import { NotesService } from '../../../services/notes.service';
import { TdoNoteQueryModel } from '../../../main-interface/controls/tdo-notes/models/tdo-note-query.model';
import { DialogService } from '../../../services/dialog.service';
import { NotesToFrontService } from 'src/app/services/notes-to-front.service';
import NotesToFrontAutoFill from 'src/app/modules/notes/models/notes-to-front-autofill/notes-to-front-autofill.model';
import { TdoDropdownChange } from 'src/app/tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import { ENUM_TYPE } from 'src/app/models/constants/enum-types.model';
import { NoteToFrontInformation } from 'src/app/models/messaging/noteToFront/note-to-front-information.model';
import { MatInput } from '@angular/material/input';
import { TaskService } from 'src/app/services/task.service';
import { restrict } from '@interactjs/modifiers/restrict/pointer';

@Component({
  selector: 'app-notification-to-front-create-dialog',
  templateUrl: './notification-to-front-create-dialog.component.html',
  styleUrls: ['./notification-to-front-create-dialog.component.scss']
})
export class NotificationToFrontCreateDialogComponent implements OnInit {

  @ViewChild('cbsb') cbsb: MatCheckbox;
  @ViewChild('cbhb') cbhb: MatCheckbox;
  @ViewChild('cbdneta') cbdneta: MatCheckbox;
  @ViewChild('drCallCheckbox') drCallCheckbox: MatCheckbox;
  @ViewChild('officeCallCheckbox') officeCallCheckbox: MatCheckbox;
  @ViewChild('drCallDateTime') drCallDateTime: MatInput;
  @ViewChild('officeCallDateTime') officeCallDateTime: MatInput;

  isLoading = true;
  isNotificationLoading = false;
  isShowHistory = false;
  nextApptEnums: EnumValidValueItemModel[];
  nextApptLengthEnums: EnumValidValueItemModel[];
  nextApptWhenEnums: EnumValidValueItemModel[];
  nextCallWhenEnums: EnumValidValueItemModel[];

  operatories: OperatoryDataModel[];

  notificationsInfo: NoteToFrontInformation;
  //notifications: NotificationToFrontDataModel[];
  users: TdoUserConfigurationModel[];
  isCaseAndTeethExists = true;
  cfgTeeth: ToothConfigurationModel[];
  selectedNotification: NotificationToFrontDataModel;

  autoAppointmentFillList: NotesToFrontAutoFill[] = [];
  constructor(private staticDataService: StaticDataService,
    private operatoryService: OperatoriesService,
    private notesService: NotesService,
    private userService: UserService,
    private taskService: TaskService,
    private notificationToFrontService: NotificationToFrontService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<NotificationToFrontCreateDialogComponent>,
    private dialogService: DialogService,
    private toothService: ToothService,
    private notesToFrontService: NotesToFrontService,
    private globals: Globals) {
  }

  ngOnInit(): void {
    /*const options = new MatDialogConfig();
    options.panelClass = 'dialog';
    this.dialog.open(LettersRecipientsDialogComponent, options);*/
    if (this.staticDataService.isReady) {
      this.setupEnums();
    } else {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.setupEnums();
        }
      });
    }
    this.notesToFrontService.getNotesToFrontAutofillModels(this.globals.TDOCID).subscribe((config) => {
      this.autoAppointmentFillList = config;
    });
  }

  setupEnums() {
    this.nextApptEnums = this.staticDataService.getValidValueItemsByValidValueName(ENUM_TYPE.enumNextAppt);
    this.nextApptLengthEnums = this.staticDataService.getValidValueItemsByValidValueName('enumNextApptLength');
    this.nextApptWhenEnums = this.staticDataService.getValidValueItemsByValidValueName('enumNextApptWhen');
    this.nextCallWhenEnums = this.staticDataService.getValidValueItemsByValidValueName('enumNextCallWhen');
    this.loadData();
  }

  loadData() {
    if (!this.globals.currentPatientCaseId) {
      this.isCaseAndTeethExists = false;
      this.isLoading = false;
      return;
    }

    this.notificationToFrontService.getCaseTeethCount(this.globals.currentPatientCaseId).subscribe((count) => {
      if (count > 0) {
        this.userService.getUsers(this.globals.TDOCID).subscribe((users) => {
          this.users = users;

          this.operatoryService.getLocationOperatories(this.globals.LOCID).subscribe((res) => {
            this.operatories = res;

            this.toothService.getAllTeeth(ToothService.enumUnitedStatesToothGrouping).subscribe((teeth) => {
              this.cfgTeeth = teeth;

              this.getNotifications();
            });
          });
        });
      } else {
        this.isCaseAndTeethExists = false;
        this.isLoading = false;
      }
    });
  }

  getNotifications() {
    const caseId = this.isShowHistory ? Constants.emptyGuid : this.globals.currentPatientCaseId;// is this correct?
    this.notificationToFrontService.getNotificationsInfo(this.globals.currentPatientId, caseId).subscribe((info) => {
      this.notificationsInfo = info;

      if (this.notificationsInfo.notifications && this.notificationsInfo.notifications.length > 0) {
        this.selectedNotification = this.notificationsInfo.notifications[0];
        this.setNotes();
      }
      /*this.notifications = this.notifications.sort((a, b) => {
        return new Date(b.xauditCreatedOn).getTime() - new Date(a.xauditCreatedOn).getTime();
      });*/
      this.isLoading = false;
    });
  }


  onOkClick() {
    this.dialogRef.close();
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  getCreationString(notification: NotificationToFrontDataModel) {
    // Created by NAME on: June 20, 2021 14:55
    const user = this.users.find(p => p.UserID === notification.xauditCreatedBy);
    const date = new Date(notification.xauditCreatedOn.toString().endsWith('Z') ? notification.xauditCreatedOn : notification.xauditCreatedOn + 'Z');
    return 'Created by ' + user.FirstName + ' ' + (user.LastName ?? ' ') + ' on: ' + date.toLocaleString();
  }

  getValueByKey(appt: NotificationToFrontAppointmentDataModel, key: string) {
    let enu: EnumValidValueItemModel;
    switch (key) {
      case 'enumNextApptID':
        enu = this.nextApptEnums.find(p => p.ValidValueItemId === appt[key]);
        if (enu) {
          return enu;
        }
        break;
      case 'enumNextApptLengthID':
        enu = this.nextApptLengthEnums.find(p => p.ValidValueItemId === appt[key]);
        if (enu) {
          return enu;
        }
        break;
      case 'enumNextApptWhenID':
        enu = this.nextApptWhenEnums.find(p => p.ValidValueItemId === appt[key]);
        if (enu) {
          return enu;
        }
        break;
    }
  }

  // Appt dropdowns
  onNextApptChange(event: any, appt: NotificationToFrontAppointmentDataModel) {
    appt.enumNextApptID = event.value.ValidValueItemId;
    this.notificationToFrontService.saveAppointment(appt).subscribe((res) => {
      appt = res;
    });
  }

  onApptLengthChange(event: any, appt: NotificationToFrontAppointmentDataModel) {
    appt.enumNextApptLengthID = event.value.ValidValueItemId;
    this.notificationToFrontService.saveAppointment(appt).subscribe((res) => {
      appt = res;
    });
  }

  onApptWhenChange(event: any, appt: NotificationToFrontAppointmentDataModel) {
    appt.enumNextApptWhenID = event.value.ValidValueItemId;
    this.notificationToFrontService.saveAppointment(appt).subscribe((res) => {
      appt = res;
    });
  }

  onItemsNeededClick() {
    const config = new MatDialogConfig();
    config.data = this.selectedNotification.CaseWorkItemId;
    config.panelClass = 'dialog';
    this.dialog.open(NotificationToFrontItemsNeededDialogComponent, config);
  }

  getComment(notification: NotificationToFrontDataModel) {
    if (notification.Comment && notification.Comment.length > 0) {
      return notification.Comment;
    } else {
      return 'Comment';
    }
  }

  onCommentInputFinish(event: any, notification: NotificationToFrontDataModel) {
    notification.Comment = event;
    this.notificationToFrontService.saveNotification(notification).subscribe((res) => {
      notification = res;
    });
  }

  createTask(notification: NotificationToFrontDataModel) {
    this.dialogService.openTasks();
  }

  createInternalMessage(notification: NotificationToFrontDataModel) {
    this.dialogService.openInternalMessaging();
  }

  getTeeth(notification: NotificationToFrontDataModel) {
    let ret = '';
    let i = 0;
    for (const t of notification.dataPatientCaseWorkItemTeeth) {
      const tooth = this.cfgTeeth.find(p => p.ToothId === t.ToothID);
      if (tooth) {
        if (i === 0) {
          ret += tooth.cfgToothDescriptions[0].Notation;
        } else {
          ret += ', ' + tooth.cfgToothDescriptions[0].Notation;
        }
        i++;
      }
    }
    return ret;
  }

  createNewNotificationForWorkItem(notification: NotificationToFrontDataModel) {
    const newNotification = new NotificationToFrontDataModel();
    newNotification.CaseWorkItemId = notification.CaseWorkItemId;
    newNotification.PatientID = notification.PatientID;
    this.notificationToFrontService.saveNotification(newNotification).subscribe((noti) => {
      //
      this.getNotifications();
    });
  }

  isOldRecord(notification: NotificationToFrontDataModel) {
    let notificationsForWorkItem = this.notificationsInfo.notifications.filter(p => p.CaseWorkItemId === notification.CaseWorkItemId);
    notificationsForWorkItem = notificationsForWorkItem.sort((a, b) => {
      return new Date(b.xauditCreatedOn).getTime() - new Date(a.xauditCreatedOn).getTime();
    });

    const idx = notificationsForWorkItem.findIndex(p => p === notification);
    if (idx > 0) {
      return true;
    }

    return false;
  }

  onShowHistoryChange($event: any) {
    this.getNotifications();
  }

  onOperatoryClick(notification: NotificationToFrontDataModel, appt: NotificationToFrontAppointmentDataModel, op: OperatoryDataModel) {
    if (!appt.dataNotificationToFrontOperatories.map(p => p.OperatoryId).includes(op.OperatoryId)) {
      const dataOp = new NotificationToFrontOperatoryDataModel();
      dataOp.OperatoryId = op.OperatoryId;
      appt.dataNotificationToFrontOperatories.push(dataOp);
      this.saveNotification(notification);
    } else {
      const idx = appt.dataNotificationToFrontOperatories.findIndex(p => p.OperatoryId === op.OperatoryId);
      this.notificationToFrontService.deleteOperatory(appt.dataNotificationToFrontOperatories[idx].NoteToFrontOpID).subscribe(() => {
        //
      });
      if (idx > -1) {
        appt.dataNotificationToFrontOperatories.splice(idx, 1);
      }
    }
  }

  saveNotification(notification: NotificationToFrontDataModel) {
    this.isNotificationLoading = true;
    this.notificationToFrontService.saveNotification(notification).subscribe((res) => {
      this.isNotificationLoading = false;
    });
  }

  saveAppointment (appt: NotificationToFrontAppointmentDataModel, notification: NotificationToFrontDataModel) {
    this.isNotificationLoading = true;
    this.notificationToFrontService.saveAppointment(appt).subscribe((res) => {
      this.isNotificationLoading = false;
      if (!notification.dataNotificationToFrontAppoitments.some( a => a.NoteToFrontApptID == res.NoteToFrontApptID))
        notification.dataNotificationToFrontAppoitments.push(res);
    });
  }

  isOpSelected(appt: NotificationToFrontAppointmentDataModel, op: OperatoryDataModel) {
    return appt.dataNotificationToFrontOperatories.findIndex(p => p.OperatoryId == op.OperatoryId) >= 0;
  }

  createNewAppointment(notification: NotificationToFrontDataModel) {
    const appt = new NotificationToFrontAppointmentDataModel();
    appt.NotificationFrontID = notification.NotificationFrontID;
    this.saveAppointment(appt, notification)
  }

  deleteAppointment(appt: NotificationToFrontAppointmentDataModel) {
    this.notificationToFrontService.deleteNoteAppointment(appt).subscribe({
      next: (res) => {
      const notification = this.notificationsInfo.notifications.find(n => n.NotificationFrontID == appt.NotificationFrontID);
      const appointmentDeleted = notification.dataNotificationToFrontAppoitments.findIndex(ap => ap.NoteToFrontApptID == appt.NoteToFrontApptID);
      if (appointmentDeleted>=0)
        notification.dataNotificationToFrontAppoitments.splice(appointmentDeleted, 1);
      },
      error: (error) => {                              //Error callback
        console.error('Error on deleteNoteAppointment', error);
      }
  });
  }

  onPatientStatusChange(event: MatCheckboxChange, flag: string) {
    this.notificationToFrontService.changePatientStatusFlags(this.globals.currentPatientId, this.cbsb.checked, this.cbhb.checked, this.cbdneta.checked).subscribe((res) => {

    });
  }

  onCallTaskChange(event: MatCheckboxChange, dateTimeControl: HTMLInputElement) {
    const userId = event.source.id == "drCallCheckbox" ? this.globals.currentProviderDoctorUserID : null;
    this.SetCallTask(event.checked, userId, dateTimeControl.value);
  }

  onCallTaskTimeChange(event: any, taskCheckbox: MatCheckbox) {
    const userId = taskCheckbox.id == "drCallCheckbox" ? this.globals.currentProviderDoctorUserID : null;
    this.SetCallTask(taskCheckbox.checked, userId, event.target.value);
  }


  SetCallTask(enabled: boolean, userId: string, dateTime: string) {
    this.isNotificationLoading = true;
    if (new Date(dateTime).toUTCString() != "Invalid Date") {
      const taskInfo = {
        patientCaseID: this.globals.currentPatientCaseId,
        noteToFrontApptID: this.selectedNotification?.NotificationFrontID,
        patientID: this.globals.currentPatientId,
        doctorID: userId,
        dueDate: new Date(dateTime).toUTCString(),
        locID: this.globals.LOCID,
        subject: `Call Patient RE: Work Item / Tooth # ${this.getTeeth(this.selectedNotification)} followup`,
        enabled: enabled
      };
      this.taskService.setNotesToFrontCallTask(taskInfo).subscribe((res) => {
      }
      );
    }
  }

  onNotificationCallTaskChange(event: EnumValidValueItemModel, taskCheckbox: MatCheckbox, dateTimeControl: HTMLInputElement) {
    const vvid = event.ValidValueItemId;
    taskCheckbox.checked = true;
    const date = new Date();
    let daysToAdd = 0;

    switch (vvid) {
      case NextCallWhenEnum.TODAY:
        daysToAdd = 0;
        break;
      case NextCallWhenEnum.TOMORROW:
        daysToAdd = 1;
        break;
      case NextCallWhenEnum.TWO_DAYS:
        daysToAdd = 2;
        break;
      case NextCallWhenEnum.THREE_DAYS:
        daysToAdd = 3;
        break;
      case NextCallWhenEnum.ONE_WEEK:
        daysToAdd = 7;
        break;
      case NextCallWhenEnum.TWO_WEEKS:
        daysToAdd = 14;
        break;
      case NextCallWhenEnum.THREE_WEEKS:
        daysToAdd = 21;
        break;
      case NextCallWhenEnum.SIX_WEEKS:
        daysToAdd = 42;
        break;
      case NextCallWhenEnum.ONE_MONTH:
        daysToAdd = 30;
        break;
    }

    date.setDate(date.getDate() + daysToAdd);
    const str = formatDate(date, 'yyyy-MM-ddTHH:mm', 'en_US');
    dateTimeControl.value = str;

    const userId = taskCheckbox.id == "drCallCheckbox" ? this.globals.currentProviderDoctorUserID : null;
    this.SetCallTask(taskCheckbox.checked, userId, dateTimeControl.value);
  }


  onClickNotification(notification: NotificationToFrontDataModel) {
    if (this.selectedNotification?.NotificationFrontID != notification.NotificationFrontID) {
      this.selectedNotification = notification;
      this.setNotes();
    }
  }

  setNotes() {
    const noteQueryModel = new TdoNoteQueryModel();
    noteQueryModel.parentObjectName = 'dataNotificationToFront';
    noteQueryModel.objectId = this.selectedNotification.NotificationFrontID;
    noteQueryModel.patientId = this.globals.currentPatientId;
    this.notesService.changeNoteQuery(noteQueryModel);
  }


  markToBeCompleted(notification: NotificationToFrontDataModel) {
    this.notificationToFrontService.markToBeCompleted(notification).subscribe(() => {
    });
  }

  deleteNotification(notification: NotificationToFrontDataModel) {
    this.notificationToFrontService.deleteNotification(notification).subscribe((res) => {
      this.dialogService.openConfirmDialog('Are you sure you want to delete this item?').subscribe((res1) => {
        if (res1) {
          const idx = this.notificationsInfo.notifications.findIndex(p => p.NotificationFrontID.toLowerCase() === notification.NotificationFrontID.toLowerCase());
          if (idx > -1) {
            this.notificationsInfo.notifications.splice(idx, 1);
          }
        }
      });
    });
  }

  onAutoAppointmentFillSelect(event: TdoDropdownChange, notification: NotificationToFrontDataModel) {
    const selectedAutoFill: NotesToFrontAutoFill = event.value;
    if (selectedAutoFill != null) {
      notification.dataNotificationToFrontAppoitments.forEach((appt, index) => { 
        this.deleteAppointment(appt); });;
      selectedAutoFill.cfgNoteToFrontAutoFillDetails
        .sort((a, b) => a.AutoFillOrder - b.AutoFillOrder)
        .forEach((appt, index) => {
          const newAppt: NotificationToFrontAppointmentDataModel = new NotificationToFrontAppointmentDataModel();
          newAppt.NotificationFrontID = notification.NotificationFrontID;
          newAppt.enumNextApptID = appt.enumNextApptID;
          newAppt.enumNextApptLengthID = appt.enumNextApptLengthID;
          newAppt.enumNextApptWhenID = appt.enumNextApptWhenID;
          appt.cfgNoteToFrontAutoFillDetailOperatories.forEach((op) => {
            const newOperatory: NotificationToFrontOperatoryDataModel = new NotificationToFrontOperatoryDataModel();
            newOperatory.OperatoryId = op.OperatoryId;
            newOperatory.OperatoryName = op.OperatoryName;
            newAppt.dataNotificationToFrontOperatories.push(newOperatory);
          });
          this.saveAppointment(newAppt, notification)
        }
        );
    }
  }
}
